import { tokenManager, type AuthTokens } from '@/libs/token-manager';
import type { AcceptBrandSignupInvitationResponse } from '@fluenceur/types';
import { resetProductAnalytics } from '@/libs/product-analytics';

/**
 * Stores the session a brand account creation answers with. The invitation
 * acceptance and the self sign-up answer the same shape, and the dashboard
 * keeps it the same way whichever created the account.
 */
export function storeBrandSessionTokens(
  token: AcceptBrandSignupInvitationResponse['token']
): AuthTokens {
  const tokens: AuthTokens = {
    accessToken: token.accessToken,
    refreshToken: token.refreshToken || token.accessToken,
    type: token.type,
    expiresIn: token.expiresIn,
  };

  resetProductAnalytics();
  tokenManager.setTokens(tokens);

  return tokens;
}
